<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Criação de Documentos
          <q-icon
            style="cursor: pointer"
            name="info"
            @click="informacaoUpload = true"
          />
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2">
        <div co>Unidade</div>
        <ListaUnidadesSelectVue />
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <label
            class="btn-upload row col-12"
            for="arquivo"
            style="cursor: pointer"
          >
            <div class="col-12 q-mt-md">
              <q-btn
                icon="upload"
                label="Selecionar Arquivo"
                color="primary"
                style="z-index: -1"
                class="btn"
                no-caps
                outline
                dense
              />
              <span class="q-mt-sm q-ml-sm texto-upload">{{
                file != null ? file.name : "Nenhum arquivo selecionado"
              }}</span>
            </div>
          </label>
          <input
            id="arquivo"
            type="file"
            @change="onFileSelected"
            @click="resetValue()"
          />
        </div>
      </div>
      <div class="btn-gerar-container">
        <p></p>
        <q-btn
          class="q-mt-sm btn-enviar"
          icon="check_circle_outline"
          label="Enviar"
          color="positive"
          dense
          no-caps
          @click="enviarArquivo()"
        />
      </div>
    </div>
    <q-dialog v-model="informacaoUpload">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/gestao_de_documento/Criac%CC%A7a%CC%83o_Documentos.csv"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script setup>
import { useQuasar } from "quasar";
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";

import ListaUnidadesSelectVue from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const store = useStore();
const quasar = useQuasar();

let unidade = ref({
  nome: store.state.org.unidadeData,
  id: store.state.org.unidadeData.id,
});
const file = ref(null);
let informacaoUpload = ref(false);
const slide = ref(0);

const onFileSelected = async (e) => {
  if (e.target.files[0].length === 0) {
    return;
  }
  file.value = e.target.files[0];
};

const enviarArquivo = async () => {
  if (
    store.state.org.unidadeData.id === "" ||
    store.state.org.unidadeData.id === null ||
    store.state.org.unidadeData.id == undefined
  ) {
    quasar.notify({
      message: "Selecione uma unidade para fazer upload.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (file.value == null) {
    quasar.notify({
      message: "Selecione um arquivo.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (file.value.name.split(".").pop() != "csv") {
    quasar.notify({
      message: "O arquivo tem que ser do tipo .csv",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  const response = await store.dispatch("documento/gerarUrlUpload");
  let formAttributes = response.data.resultado.dados.formAttributes;
  let formInputs = response.data.resultado.dados.formInputs;
  const formData = new FormData();

  for (let input in formInputs) {
    formData.append(input, formInputs[input]);
  }

  formData.append("file", file.value);
  let request = new XMLHttpRequest();
  request.open(formAttributes.method, formAttributes.action);
  request.send(formData);
  try {
    await store.dispatch("documento/fazerUploadArquivo", {
      url: `${formAttributes.action}/${formInputs.key}`,
      unidadeId: store.state.org.unidadeData.id,
    });
    quasar.notify({
      message: "Documento(s) adicionados com sucesso.",
      color: "positive",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    file.value = null;
    resetValue();
  } catch (error) {
    quasar.notify({
      message: "Erro ao fazer upload de documentos.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const resetValue = () => {
  const input = document.getElementById("arquivo");
  input.value = null;
};

watch(
  () => store.state.org.unidadeData,
  () => {
    unidade.value.nome = store.state.org.unidadeData;
    unidade.value.id = store.state.org.unidadeData.id;
  }
);

const getUnidade = () => {
  if (
    localStorage.unidade &&
    localStorage.unidade != null &&
    localStorage.unidade != "null"
  ) {
    let getunidade = localStorage.getItem("unidade");
    unidade.value.nome = JSON.parse(getunidade);
  }
};

onMounted(getUnidade);
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-upload {
  margin: 9px 0px 0px 0px;
}
a {
  text-decoration: none;
  color: white;
}
</style>
